var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAngryAnnoyedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 70,
    viewBox: "0 0 69 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 68.0045C53.0015 68.0045 68 53.005 68 34.5022C68 15.9995 53.0015 1 34.5 1C15.9985 1 1 15.9995 1 34.5022C1 53.005 15.9985 68.0045 34.5 68.0045Z",
    fill: "white",
    stroke: "#231F20",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0332 51.1582H44.5859",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7598 47.1738L46.9782 55.7289",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7158 42.0413C27.2619 42.0413 30.9472 36.9629 30.9472 30.6984C30.9472 24.4339 27.2619 19.3555 22.7158 19.3555C18.1697 19.3555 14.4844 24.4339 14.4844 30.6984C14.4844 36.9629 18.1697 42.0413 22.7158 42.0413Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7153 38.882C24.9884 38.882 26.831 36.3428 26.831 33.2105C26.831 30.0783 24.9884 27.5391 22.7153 27.5391C20.4423 27.5391 18.5996 30.0783 18.5996 33.2105C18.5996 36.3428 20.4423 38.882 22.7153 38.882Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3182 16.113C55.3182 16.113 49.8744 13.7678 43.4735 16.5676C43.4735 16.5676 37.7307 19.2957 35.9121 25.2064C35.9121 25.2064 43.7607 17.3813 55.3182 16.113Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9082 16.113C13.9082 16.113 19.352 13.7678 25.7529 16.5676C25.7529 16.5676 31.4957 19.2957 33.3143 25.2064C33.3143 25.2064 25.4657 17.3813 13.9082 16.113Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0752 42.0413C51.6213 42.0413 55.3066 36.9629 55.3066 30.6984C55.3066 24.4339 51.6213 19.3555 47.0752 19.3555C42.5291 19.3555 38.8438 24.4339 38.8438 30.6984C38.8438 36.9629 42.5291 42.0413 47.0752 42.0413Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0747 38.882C49.3477 38.882 51.1904 36.3428 51.1904 33.2105C51.1904 30.0783 49.3477 27.5391 47.0747 27.5391C44.8017 27.5391 42.959 30.0783 42.959 33.2105C42.959 36.3428 44.8017 38.882 47.0747 38.882Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngryAnnoyedIcon);
export default __webpack_public_path__ + "static/media/angry-annoyed-icon.e5dd25da927aa0cd8e15263a8253fb41.svg";
export { ForwardRef as ReactComponent };